import React, { useState, useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';

const TimeAgoComponent = ({ givenDate }) => {
  const [formattedDistance, setFormattedDistance] = useState(formatDistanceToNow(new Date(givenDate)));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setFormattedDistance(formatDistanceToNow(new Date(givenDate)));
    }, 1000); 

    return () => clearInterval(intervalId); 
  }, [givenDate]);

  return (
    <p>{formattedDistance}</p>
  );
};

export default TimeAgoComponent;

